import React from 'react';
import Chart from 'react-apexcharts';
// import dummyData from "../data.json"; // Importing the JSON data

const CustomerEngagementChart = () => {
  // const zones = dummyData.customerProductEngagement.zones;
  const zones = [];
  // Extracting categories (zone names)
  // const categories = Object.keys(zones);
  const categories = [];

  // Extracting series data dynamically
  const seriesData = ['Viewed', 'Touched', 'Compaired', 'Picked'].map((key) => ({
    name: key,
    data: categories.map((zone) => zones[zone][key])
  }));

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false }
    },
    xaxis: {
      categories,
      title: {
        text: 'Zones' // X-Axis Title
      }
    },
    yaxis: {
      title: {
        text: 'Customer Interactions' // Y-Axis Title
      }
    },
    stroke: {
      show: true,
      width: 6,
      colors: ['transparent']
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 7,
        borderRadiusApplication: 'end',
        columnWidth: '55%',
        barGap: 10
      }
    },
    colors: ['#329242', '#44BE54', '#76D183', '#A8E4B1'], // Analogous colors (Blue-Violet range)
    dataLabels: { enabled: false },
    legend: {
      position: 'top'
    }
  };

  return (
    <div>
      <Chart options={chartOptions} series={seriesData} type="bar" height={400} />
    </div>
  );
};

export default CustomerEngagementChart;
